import React, { useState, useEffect } from 'react';
import {
  Authenticator,
  SignUp,
  ForgotPassword,
  Greetings,
  SignIn,
} from 'aws-amplify-react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Alert from '@material-ui/lab/Alert';
import CustomLogin from './Login';
import CustomForgotPassword from './ForgotPassword';
import theme from './AmplifyTheme'
import { grey, lightBlue } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  form: {
    position: 'relative',
  },
  formContainer: {
    // 'width': '90%',
    'margin': '0 auto',
    // 'padding': '.5rem 2.5rem 0',
    '& div[class^="Form__formContainer"]': {
      marginBottom: 0,
    },
  },
  formContaineTop: {
    margin: '0 auto',
    textAlign: 'center',
    marginBottom: '1.5rem',
    color: grey[800],
  },
  subHeading: {
    color: grey[700],
    fontSize: '1.2rem',
  },
  formFooter: {
    margin: '1.5rem 0 ',
    textAlign: 'center',
    color: grey[600],
  },
  submitBtn: {
    'backgroundColor': lightBlue[600],
    'marginTop': '1rem',

    '&:hover': {
      backgroundColor: lightBlue[700],
    },
  },
  linkLine: {
    color: lightBlue[600],
    fontWeight: 400,
  },
}));


const SignInComponent = () => {
  const classes = useStyles();
  const [showPasswordHint, setShowPasswordHint] = useState(false);
  const onStateChange = (state) => {
    console.log(state,'state')
    if (state === 'signedIn') {
      window.location.assign('/');
    } else if (state === 'forgotPassword' || state === 'requireNewPassword') {
      setShowPasswordHint(true);
    } else {
      setShowPasswordHint(false);
    }
  };

  return (
    <Box className={classes.formContainer}>
      <Authenticator
        hide={[SignIn, Greetings, SignUp, ForgotPassword]}
        onStateChange={onStateChange}
        theme={theme}
      >
        <CustomLogin />
        <CustomForgotPassword />
      </Authenticator>
      {showPasswordHint && (
        <Box maxWidth={460} marginLeft="auto" marginRight="auto" marginBottom={2} paddingLeft={2} paddingRight={2}>
          <Alert variant="filled" severity="info">
            Password must be minimum 8 characters long and a combination of
            uppercase letters, lowercase letters, number, special characters.
          </Alert>
        </Box>
      )}
    </Box>
  );
};

export default SignInComponent;
